<template>
  <div class="thal-page">
    <div class="calendar-page">
      <div class="calendar-back" @click.stop="_back"><i class="el-icon-arrow-left" /></div>
      <div class="calendar-check " @click.stop="_check_type(item.is_hf,item.id)" :class="{'color_calendar': isType==item.is_hf}" v-for="(item,index) in lottery_list">{{ item.lottery_name}}</div>
<!--      <div class="calendar-check" @click.stop="_check_type(2)" :class="{'color_calendar': isType==2}">{{$t('thalIndex.t_8')}}</div>-->
    </div>
    <div class="calendar-list" v-if="isType==1">
      <div class="month-con">
        <div v-if="time.month<1" class="prevmonth"></div>
        <div v-else @click="reduceMonth()" class="prevmonth">
          <i class="el-icon-arrow-left" />
          <!--<span>{{time.month}}月</span>-->
        </div>
        <span class="month"
        >{{ time.year }}-{{
                time.month + 1 > 9 ? time.month + 1 : '0' + (time.month + 1)
              }}</span
        >
        <div v-if="time.month+2>12" class="nextmonth"></div>
        <div v-else @click="addMonth()" class="nextmonth">
          <!--  <span>{{time.month+2}}月</span>-->
          <i class="el-icon-arrow-right" />
        </div>
      </div>
      <div class="tablemain">
        <div class="top-con">
          <div class="top" v-for="item in top" :key="item">{{ item }}</div>
        </div>
        <div class="date-con">
          <div
            class="date"
            v-for="(item, index) in visibleCalendar"
            :key="index"
          >
            <div class="day-num">{{ item.day }}</div>
            <div class="content" v-if="item.day!=''">
              <div v-for="(twoitem,indexs) in item.record" :key="indexs">{{ twoitem.stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":")[1]+':'+twoitem.stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":")[2]}}<span>{{twoitem.open_code}}</span></div>
<!--              <div>12:01<span>84</span></div>
              <div>2:00<span>84</span></div>
              <div>4:30<span>84</span></div>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="calendar-list" v-if="isType==0">
      <div class="month-con">
        <div @click="_reduceYear()" class="prevmonth">
          <i class="el-icon-arrow-left" />
          <!--<span>{{time.month}}月</span>-->
        </div>
        <span class="month">{{ year }}</span>
        <div  @click="_addYear()" class="nextmonth">
          <!--  <span>{{time.month+2}}月</span>-->
          <i class="el-icon-arrow-right" />
        </div>
      </div>
      <div class="item-3d">
        <div class="item-3d-list" v-for="item in month_list">
          <div class="item-3d-name">{{item.title}}</div>
          <div class="item-3d-num" v-for="(twoitem,index) in item.record">{{ twoitem.open_code }}</div>
        </div>
      </div>
    </div>


  </div>
</template>


<script>
  export default {
    data() {
      return {
        isType:2,
        time:{
          year: new Date().getFullYear(),
          month: new Date().getMonth()
        },
        top: ['Sun','Mon', 'Tue', ' Wed', ' Thur', ' Fri', 'Sat'],
        year:new Date().getFullYear(),
        yearTop:['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'],
        yearNum:[1,2,3,4,5,6,7,8,9,10,11,12],
        platform_id:'',
        lottery_list:[],
        lottery_id:'',
        month_list:[
          {'title':'JAN',month:'1',record: []},
          {'title':'FEB',month:'2',record: []},
          {'title':'MAR',month:'3',record: []},
          {'title':'APR',month:'4',record: []},
          {'title':'MAY',month:'5',record: []},
          {'title':'JUN',month:'6',record: []},
          {'title':'JUL',month:'7',record: []},
          {'title':'AUG',month:'8',record: []},
          {'title':'SEP',month:'9',record: []},
          {'title':'OCT',month:'10',record: []},
          {'title':'NOV',month:'11',record: []},
          {'title':'DEC',month:'12',record: []},
        ],
      }
    },
    created() {
      let _self=this;
      let platform_id=_self.$route.query.platform_id;
      if(platform_id!='' && platform_id!=undefined){
        _self.platform_id=platform_id;
        this._lottery();

      }

    },
    computed: {
      // 获取当前月份显示日历
      visibleCalendar: function() {
        this.yearMonth = this.time.year+'-'+(this.time.month+1)
        const calendarArr = []
        // 获取当前月份第一天
        const currentFirstDay = new Date(this.time.year, this.time.month, 1)
        // 获取第一天是周几
        const weekDay = currentFirstDay.getDay()
        // 获取一个月的总天数
        const monthsDays = new Date(this.time.year, this.time.month+1, 0).getDate()
        // 用当前月份第一天减去周几前面几天，就是看见的日历的第一天
        const startDay = currentFirstDay - (weekDay - 0) * 24 * 3600 * 1000
        // 日历需要的格子总数 行数*7
        const totalgrid = Math.ceil((monthsDays+weekDay)/7)*7
        for (let i = 0; i < totalgrid; i++) {
          const date = new Date(startDay + i * 24 * 3600 * 1000)
          if (i<weekDay || i>monthsDays+weekDay-1) {
            calendarArr.push({
              date: '',
              year: '',
              month: '',
              day: '',
              record:[],
            })
          } else {
            calendarArr.push({
              date: new Date(startDay + i * 24 * 3600 * 1000),
              year: date.getFullYear(),
              month: date.getMonth(),
              day: date.getDate(),
              record:[],
            })
          }
        }


        return calendarArr;
      },
      /*this._time_record();*/
    },
    methods:{
      _lottery:function (){
        let _self=this;
        this._PublicFun.getData('1', 'get', 'lottery/'+_self.platform_id, {}, function (result) {
          if(result.data['status_code']==200){
            _self.lottery_list=result.data['data'];
            if(_self.lottery_list.length>0){
              _self.lottery_id=_self.lottery_list[0].id;
              _self.isType=_self.lottery_list[0].is_hf;
              _self._history()
            }

          }
        })
      },
      _history:function (){
        let _self=this;
        let url='';
        if(_self.isType==0){
          url='lottery/history_record/'+_self.lottery_id+'?search_date='+_self.year;
        }else if(_self.isType==1){
          let month=_self.time.month + 1 > 9 ? _self.time.month + 1 : '0' + (_self.time.month + 1)

          url='lottery/history_record/'+_self.lottery_id+'?search_date='+_self.time.year+'-'+month;
        }
        this._PublicFun.getData('2', 'get', url, {}, function (result) {
          if(result.data['status_code']==200){
            if(result.data['data'].length>0){
              _self.list=_self._formatTrackList(result.data['data']);
              if(_self.isType==1){
                if(_self.visibleCalendar.length>0){
                  _self._time_record();
                }
              }else if(_self.isType==0){
                _self._data_time();
              }


            }
          }
        })
      },
      _time_record:function (){
        let _self=this;
          for(var i in _self.list){
            let day=i.replace(" ", ":").replace(/\\:/g, "-").split("-")[2];
            for(var a=0;a<_self.visibleCalendar.length;a++){
              if(parseFloat(day)==parseFloat(_self.visibleCalendar[a].day)){
                _self.visibleCalendar[a].record=_self.list[i];
              }

            }

          }
          this.$forceUpdate();
      },
      _formatTrackList:function (data){
        let _self=this;
        let result = data.reduce((acc, item, i) => {
          if(_self.isType==1){

            if (i && item.lottery_date.replace(/T.*/, "") === data[i-1].lottery_date.replace(/T.*/, "")) {
              /* acc[acc.length-1].push(item);*/
              acc[item.lottery_date].push(item);
            } else {
              acc[item.lottery_date]=[item];
            }
          }else if(_self.isType==0){
            if(i && item.lottery_date.replace(" ", ":").replace(/\\:/g, "-").split("-")[1] ===  data[i-1].lottery_date.replace(" ", ":").replace(/\\:/g, "-").split("-")[1]){
              acc[item.lottery_date.replace(" ", ":").replace(/\\:/g, "-").split("-")[0]+'-'+item.lottery_date.replace(" ", ":").replace(/\\:/g, "-").split("-")[1]].push(item);
            }else{
              acc[item.lottery_date.replace(" ", ":").replace(/\\:/g, "-").split("-")[0]+'-'+item.lottery_date.replace(" ", ":").replace(/\\:/g, "-").split("-")[1]]=[item];
            }
          }
          return acc;
        }, []);
        return result
      },
      _data_time:function (){
        let _self=this;
        for(var i in _self.list){
          let month=i.replace(" ", ":").replace(/\\:/g, "-").split("-")[1]
          for(var a=0;a<_self.month_list.length;a++){
            if(parseFloat(month)==parseFloat(_self.month_list[a].month)){
              _self.month_list[a].record=_self.list[i];
            }
          }
        }
        this.$forceUpdate();

      },

      _back:function () {
        this.$router.back();
      },
      _check_type:function(is_hf,id){
        let that=this;
        that.lottery_id=id;
        that.isType=is_hf;
        that._history();


      },
// 上个月
      reduceMonth() {
        if (this.time.month > 0) {
          this.time.month = this.time.month - 1;

        } else {
          this.time.month = 11
          this.time.year = this.time.year - 1
        }
        this._history();
      },
      // 下个月
      addMonth() {
        if (this.time.month < 11) {
          this.time.month = this.time.month + 1
        } else {
          this.time.month = 0
          this.time.year = this.time.year + 1
        }
        this._history();
      },
      _reduceYear:function () {
        this.year = this.year - 1;
        for(var i=0;i<this.month_list.length;i++){
          this.month_list[i].record=[];
        }
        this._history();
      },
      _addYear:function () {
        this.year = this.year + 1;
        for(var i=0;i<this.month_list.length;i++){
          this.month_list[i].record=[];
        }
        this._history();
      }

    }
  }
</script>
<style scoped>
  .calendar-page{
    position: fixed;
    top: 0;
    width: 100%;
    display: flex;
    align-items: center;
    height: 55px;
    max-width: 750px;
    left: 50%;
    transform: translateX(-50%);
    justify-content: center;
  }
  .calendar-back{
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #F0D486;
    font-size: 20px;
    cursor: pointer;
  }
  .calendar-check{
    display: block;
    width: 80px;
    text-align: center;
    color: #BEBEBE;
    font-weight: bolder;
    font-size: 18px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }
  .color_calendar{
    color: #F0D486 !important;
    border-bottom: 2px solid #F0D486;
  }
  .calendar-list{
    /*position: absolute;
    top: 55px;
    left: 0;
    bottom: 0;
    overflow-y: auto;*/

    display: block;
    margin: 55px auto 0;
    width: 100%;
    max-width: 750px;
  }
  .mycalendar {
    padding: 10px 10px;
    margin-top: 20px;
  }
  .month-con {
    display:flex;
    align-items: center;
    justify-content:space-between;
    margin-bottom: 10px;
  }
  .prevmonth,.nextmonth {
      font-size: 18px;
      color: #666;
      font-weight: 600;
      cursor: pointer;
  }
    .month {
      font-weight: 600;
      color: #fff;
      font-size: 24px;
    }

  .top-con {
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
    line-height: 40px;
    font-size: 10px;
    border-bottom: 1px solid #F0D486;
  }
    .top {
      width:14.28%;
      text-align: center;
     /* border-right: 1px solid #666666;*/
      color: #fff;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;

    }
  .date-con {
    display: flex;
    flex-wrap: wrap;
  }
    .date {
      width:14.28%;
      text-align: center;
      position: relative;
      border-bottom: 1px solid #F0D486;
    }
    .date:after{
      position: absolute;
      content: '';
      top: 0;
      bottom: 0;
      right: 0;
      border-right: 1px solid #F0D486;


    }
    .date:first-child:before,.date:nth-child(7n+1):before{
      position: absolute;
      content: '';
      left: 0;
      top: 0;
      bottom: 0;
      border-left: 1px solid #F0D486;
    }
    .day-num {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      font-weight: bold;
      /*border-bottom: 1px solid #666666;*/
      color: #F0D486;

    }
    .content {
      height:80px;
      font-size: 12px;
      color: #222;
     /* padding: 3px 5px 8px;*/
      box-sizing: border-box;
      text-align:left;
    }
  .content div{
    display: block;
    width: 90%;
    margin: 0 auto;
    padding: 0;
    position: relative;
    font-size: 12px;
    color: #AFAFAF;
    height: 20px;
    line-height: 20px;
  }
  .content div span{
    position: absolute;
    right: 0;
    font-weight: bold;
    font-size: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #ffffff;
  }
  .item-3d{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    clear: both;
  }
  .item-3d-list{
    display: block;
    width: 30%;
    margin: 5px 1.1%;
    padding: 0;
    float: left;
    border: 1px solid #F0D486;
    min-height: 60px;
    border-radius: 5px;
  }
  .item-3d-list:nth-child(3n+1){
    margin-left: 2.2%;
  }
  .item-3d-name{
    display: block;
    text-align: left;
    text-indent: 0.5rem;
    color: #F0D486;
    padding: 5px 0;
    font-size: 10px;
    font-weight: bold;
    zoom: 0.8;
  }
  .item-3d-num{
    display: block;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    color: #ffffff;
    line-height: 22px;
  }
  .item-3d-num:last-child{
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/THAL/calendar.vue